import { useFindProfile } from './profile'

type Role =
  | 'global-admin'
  | 'mechanical'
  | 'technician'
  | 'flsupervisor'
  | 'scheduler'
  | 'process'
  | 'admin'
  | 'read'

export function useRoles() {
  const { data: user } = useFindProfile()

  function isUserAllowed(roles: Role[]) {
    if (roles.length === 1 && roles[0] === 'read') {
      const isReadOnlyUser =
        user?.selectedSite?.roles.length === 1 &&
        user?.selectedSite?.roles.some((role) => roles.includes(role))
      return isReadOnlyUser
    }
    if (user?.isGlobalAdmin && roles.includes('global-admin')) {
      return true
    }
    const isAllowed = user?.selectedSite?.roles.some((role) =>
      roles.includes(role),
    )
    return isAllowed
  }

  const mechanicalRoles = [
    'global-admin',
    'admin',
    'mechanical',
    'scheduler',
    'process',
  ] as Role[]

  const readOnlyUserRoles = ['read'] as Role[]

  const adminRoles = ['global-admin', 'admin', 'scheduler'] as Role[]

  return {
    isUserAllowed,
    mechanicalRoles,
    readOnlyUserRoles,
    adminRoles,
  }
}
